var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewPolicyLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M11.2 11.636a6.992 6.992 0 0 0-.262 9.969 7.156 7.156 0 0 0 10.046.262 6.992 6.992 0 0 0 .262-9.969 7.166 7.166 0 0 0-10.046-.262zm8.679 1.571a5.062 5.062 0 0 1-.194 7.215 5.236 5.236 0 0 1-7.321-.194 5.062 5.062 0 0 1 .194-7.215 5.217 5.217 0 0 1 7.32.194zm2.763 8.94a.97.97 0 0 0-1.396 1.349l5.983 6.235a.97.97 0 0 0 .698.3.97.97 0 0 0 .67-.271.97.97 0 0 0 0-1.367l-5.955-6.245zm6.934-15.165a.97.97 0 0 0-.553-1.057L16.417.107a.97.97 0 0 0-.815 0L2.996 5.925a.97.97 0 0 0-.533.669.873.873 0 0 0-.039.388v7.466A17.387 17.387 0 0 0 15.632 31.03a.97.97 0 0 0 .368 0h.136a.97.97 0 0 0 .232 0 16.97 16.97 0 0 0 5.518-2.424.97.97 0 0 0-1.038-1.639 14.885 14.885 0 0 1-4.703 2.124.737.737 0 0 0-.29 0A15.399 15.399 0 0 1 4.364 14.468V7.447L16 2.037l11.636 5.41V14.468a14.458 14.458 0 0 1-2.133 7.534.97.97 0 0 0 1.658.97 16.359 16.359 0 0 0 2.415-8.524V6.982z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewPolicyLight);
export default __webpack_public_path__ + "static/media/icon-view-policy-light.cbe2a907cc99d62a9d8f3328b73ddb51.svg";
export { ForwardRef as ReactComponent };